import { useHistory } from 'react-router-dom';

export default function Footer() {
    const history = useHistory();

    return (
        <footer className="footer">
            <div onClick={() => history.push('/')} style={{ cursor: 'pointer', fontWeight: 600, color: 'var(--text-primary)' }}>
                Маск Эскорт
            </div>
            <div className="footer-links">
                <span onClick={() => history.push('/about')}>О проекте</span>
                <span onClick={() => history.push('/policy')}>Политика конфиденциальности</span>
            </div>
            <div style={{ marginTop: 4, fontSize: 11 }}>2017–2025</div>
        </footer>
    );
}
